<template>
  <div class="layout-preview">
     
    <slot />
    
  </div>
</template>
<script setup>
import { ref, computed, onMounted, watch, provide } from "vue";
import PageRender from "~/components/render/PageRender.vue";
import { useMainStore } from "../composables/store";
import {
  setPageHeaderStyleConfig
} from "~/composables/pageEditorUse"; 
</script>
  